import styled from "styled-components";

export const Container = styled.div`
  width: 100%; 
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-top: 40px;
`;

export const SkillsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const List = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;